import type { SpinProps } from "antd";
import { Space, Typography } from "antd";
import React from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";
import DataTable from "../DataTable";

const { Text } = Typography;

export interface IDomainDataPreviewListProps {
    header?: React.ReactNode;
    headerClassName?: string;
    containerClassName?: string;
    recordCount?: number;
    domainDataList?: IDomainDataResultItem[];
    /** Ant Design `SpinProps`, or a legacy `{ description }` shape still passed by some callers. */
    loading?: boolean | SpinProps | { description?: React.ReactNode };
    tableClasses?: string[];
    showRecordsHeader?: boolean;
    onPageSelect?: (pagination: IPagination) => void;
    contentStyle?: React.CSSProperties;
    headerStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    className?: string;
    emptyText?: string;
    "data-testid"?: string;
}

export default function DomainDataPreviewList({
    header,
    headerClassName = "",
    containerClassName = "",
    recordCount,
    domainDataList,
    loading,
    tableClasses = [],
    showRecordsHeader = true,
    onPageSelect,
    contentStyle,
    headerStyle,
    style,
    className = "",
    emptyText,
}: IDomainDataPreviewListProps) {
    return (
        <DataTable<IDomainDataResultItem>
            hideSelectionColumn
            fixedHeader
            contentStyle={contentStyle}
            style={style}
            headerStyle={headerStyle}
            containerClassName={containerClassName}
            contentClassName={className}
            headerClassName={headerClassName}
            header={
                <>
                    {header}
                    {showRecordsHeader && (
                        <Space orientation="horizontal">
                            <Text type="secondary">Number of records: </Text>
                            <Text type="success">{recordCount || 0}</Text>
                        </Space>
                    )}
                </>
            }
            dataTestId={CypressTestIds.MANAGE_BUSINESS_AREA_DATA_DOMAIN_DATA_PREVIEW_LIST}
            emptyText={emptyText}
            tableProps={{
                dataSource: domainDataList,
                size: "small",
                rowKey: "domainDataId",
                className: tableClasses.join(" "),
                loading: (loading || false) as boolean | SpinProps,
                pagination: {
                    placement: ["bottomEnd"],
                    defaultPageSize: 100,
                    pageSize: 100,
                },
                onChange: (pagination, _filters, _sorter, extra) => extra.action === "paginate" && onPageSelect && onPageSelect(pagination as IPagination),
                columns: [
                    {
                        width: "60px",
                        title: "No.",
                        key: "index",
                        render: (_value, item, index) => item.sNo || index + 1,
                    },
                    {
                        dataIndex: "code",
                        title: "Code",
                        render: (value) => <>{value}</>,
                    },
                    {
                        dataIndex: "description",
                        title: "Description",
                        render: (value) => <>{value}</>,
                    },
                ],
            }}
        />
    );
}
